import {
  IMetf,
  MetfBaseParams,
  EtfBrandParams,
  EtfIndustryResult,
  EtfMarketSummaryResult,
  IEtfLastShareSummaryResult,
  IEtfAssetTrendResult,
  EtfNetValue,
  IEtfCashProcess,
  IEtfCashProcessTrendItem,
  IEtfCashFlowTrendItem,
  MetricType,
  FileListType,
  LatestNetValueType,
  IEtfAssetDroTrend,
  IEtfAssetLatestDro,
  IEtfRegionTrendResult,
  IEtfHoldingDetailResult,
  IAssetTrendResult,
  IEtfNetValueTrendResult,
  IGetAllFileResult,
  EtfThousandYuan,
  EtfThousandYuanFlow,
  IEtfBondMetricTrendItem,
  IEtfTopListQuery,
} from './model';
import { ITradeForm, IAvailableShares, IPaperRecord } from './model/trade';
import { ContentTypeEnum } from '/@/enums/httpEnum';
import { defHttp } from '/@/utils/http/axios';

enum Api {
  // 查询ETF基本信息
  BASE_INFO = '/analysis/etf/base-info',

  // DRO底层资产概率（一站式收购DRO资产）
  ETF_ASSET_SUMMARY = '/analysis/etf-asset/market-summary',

  // 查询行业分布图表数据
  ETF_INDUSTRY_DISTRIBUTION = '/analysis/etf-asset/industry-distribution',

  // 查询品牌分布图表数据
  ETF_BRAND_DISTRIBUTION = '/analysis/etf-asset/brand-distribution',

  // 查询地区分布
  ETF_REGION_DISTRIBUTION = '/analysis/etf-asset/region-distribution',

  // 持仓明细
  ETF_ASSET_LIST = '/analysis/etf-asset/etf-asset-list',

  // ETF资产变动走势图
  ETF_ASSET_TREND = '/analysis/etf/asset-trend',

  // ETF净值走势图
  ETF_NET_VALUE_TREND = '/analysis/etf/net-value-trend',

  // 最新的股份变动记录
  ETF_ASSET_CHANGE = '/analysis/etf-asset/latest-share-summary',

  // 股份变动记录走势图
  ETF_ASSET_CHANGE_TREND = '/analysis/etf-asset/share-summary-trend',
  // ETF当日净值
  ETF_NET_VALUE = '/analysis/etf/latest-net-value',

  // ETF最新的现金明细
  ETF_CASH_DETAIL = '/analysis/etf-cash/latest-cash-process',
  // ETF现金变动走势图
  ETF_CASH_TREND = '/analysis/etf-cash/cash-process-trend',
  // 底层现金流走势图
  ETF_CASH_FLOW_TREND = '/analysis/etf-cash/cash-flow',

  // 总股份变动记录导出
  ETF_ASSET_CHANGE_EXPORT = '/analysis/etf-asset/share-summary-trend/total-export',
  // 流通股份变动记录导出
  ETF_ASSET_CHANGE_EXPORT_CIRCULATION = '/analysis/etf-asset/share-summary-trend/free-export',
  // 受限股份变动记录导出
  ETF_ASSET_CHANGE_EXPORT_RESTRICTED = '/analysis/etf-asset/share-summary-trend/rsu-export',
  // ETF日度指标
  ETF_DAILY_METRIC = '/analysis/etf/day-metric',
  // 查询产品文件
  FILE_LIST = '/analysis/product/file-list',

  //ETF当日净值数据
  LATEST_NET_VALUE = '/analysis/etf/latest-net-value',

  //ETF净值表现导出
  ETF_EXPORT_NET_VALUE_TREND = '/analysis/etf/export/net-value-trend',

  // DRO变动记录走势图
  ETF_ASSET_DRO_TREND = '/analysis/etf-asset/dro-summary-trend',

  // 最新的DRO变动记录
  ETF_ASSET_LATEST_DRO = '/analysis/etf-asset/latest-dro-summary',

  // 持仓明细导出
  ETF_ASSET_LIST_EXPORT = '/analysis/etf-asset/etf-asset-list/export',

  // ETF资产变动导出
  ETF_ASSET_TREND_EXPORT = '/analysis/etf/export/asset-trend',

  //底层现金流导出
  ETF_CASH_FLOW_EXPORT = '/analysis/etf-cash/export/cash-flow',

  //介绍下载
  ANALYSIS_FILE_DOWN = '/analysis/file/down',

  //metf规则新接口
  GET_ALL_FILE = '/analysis/etf-file/get-all-file',
  //千日元收款列表
  THOUSAND_YUAN_LIST = '/analysis/etf-cash/thousand-yuan',

  THOUSAND_YUAN_FLOW = '/analysis/etf-cash/thousand-yuan-flow',

  // 最新的债券指标
  ETF_BOND_METRIC = '/analysis/etf-debt/latest-debt-index',

  // 债券指标走势图
  ETF_BOND_METRIC_TREND = '/analysis/etf-debt/debt-index-list',
  // 品牌明细导出
  ETF_ASSET_BRAND_EXPORT = '/analysis/etf-asset/etf-asset-brand/export',

  // 地区明细导出
  ETF_ASSET_REGION_EXPORT = '/analysis/etf-asset/etf-asset-region/export',

  // Top5品牌变动
  ETF_ASSET_BRAND_TOP_TREND = '/analysis/etf-asset/brand-TOP5-variation',

  // Top5地区变动
  ETF_ASSET_REGION_TOP_TREND = '/analysis/etf-asset/region-TOP5-variation',

  // 提交ETF订单
  ETF_ORDER_SUBMIT = '/trade/etf/order/submit',

  // 查询可用ETF持仓
  ETF_GET_AVAILABLE_SHARES = '/trade/etf/order/get-available-share',

  //查询是否首次交易
  PAPER_GET_RECORD = '/trade/trade/paper/get-record',

  //协议签署
  PAPER_SIGH = '/trade/trade/paper/sign',
}

export const fetchEtfBaseInfoApi = (productCode: string) =>
  defHttp.get<IMetf>({ url: Api.BASE_INFO, params: { productCode } });

export const fetchEtfMarketSummary = (params: MetfBaseParams) =>
  defHttp.post<EtfMarketSummaryResult>({
    url: Api.ETF_ASSET_SUMMARY,
    params,
    headers: { 'Content-Type': ContentTypeEnum.FORM_URLENCODED },
  });

export const fetchEtfIndustryTrend = (params: MetfBaseParams) =>
  defHttp.post<EtfIndustryResult>({
    url: Api.ETF_INDUSTRY_DISTRIBUTION,
    params,
  });

export const fetchEtfBrandTrend = (params: EtfBrandParams) =>
  defHttp.post<IEtfRegionTrendResult>({
    url: Api.ETF_BRAND_DISTRIBUTION,
    params,
  });

export const fetchEtfRegionTrend = (params: EtfBrandParams) =>
  defHttp.post<IEtfRegionTrendResult>({
    url: Api.ETF_REGION_DISTRIBUTION,
    params,
  });

export const fetchEtfAssetList = (params: EtfBrandParams) =>
  defHttp.post<IEtfHoldingDetailResult>({
    url: Api.ETF_ASSET_LIST,
    params,
  });

export const fetchEtfAssetTrend = (params: MetfBaseParams) =>
  defHttp.get<IAssetTrendResult>({
    url: Api.ETF_ASSET_TREND,
    params,
  });

export const fetchEtfNetValueTrend = (params: MetfBaseParams) =>
  defHttp.get<IEtfNetValueTrendResult[]>({
    url: Api.ETF_NET_VALUE_TREND,
    params,
  });

export const fetchEtfAssetChange = (productCode: string) =>
  defHttp.get<IEtfLastShareSummaryResult>({
    url: Api.ETF_ASSET_CHANGE,
    params: { productCode },
  });

export const fetchEtfAssetChangeTrend = (productCode: string) =>
  defHttp.post<IEtfAssetTrendResult[]>({
    url: `${Api.ETF_ASSET_CHANGE_TREND}?productCode=${productCode}`,
  });

/**
 * [查询ETF当日净值](https://exmt-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/ETF%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getLatestNetValue)
 */
export const fetchEtfNetValue = (params: Pick<MetfBaseParams, 'productCode'>) =>
  defHttp.get<EtfNetValue>({
    url: Api.ETF_NET_VALUE,
    params,
  });

/**
 * [查询ETF最新的现金明细](https://exmt-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/ETF%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getLatestCashProcess)
 */
export const fetchEtfCashDetail = (productCode: string) =>
  defHttp.get<IEtfCashProcess>({
    url: Api.ETF_CASH_DETAIL,
    params: { productCode },
  });

/**
 * [查询ETF现金变动走势图](https://exmt-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/ETF%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getCashProcessTrend)
 */
export const fetchEtfCashTrend = (productCode: string) =>
  defHttp.post<IEtfCashProcessTrendItem[]>({
    url: `${Api.ETF_CASH_TREND}?productCode=${productCode}`,
  });

/**
 * [查询底层现金流走势图](https://exmt-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/ETF%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getCashFlow)
 */
export const fetchEtfCashFlowTrend = (productCode: string) =>
  defHttp.post<IEtfCashFlowTrendItem[]>({
    url: `${Api.ETF_CASH_FLOW_TREND}?productCode=${productCode}`,
  });

export const grossShareExport = (productCode: string) =>
  defHttp.get(
    {
      url: Api.ETF_ASSET_CHANGE_EXPORT,
      params: { productCode },
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

export const fetchEtfFileListApi = (params) =>
  defHttp.get<FileListType[]>({
    url: Api.FILE_LIST,
    params,
    headers: { 'Content-Type': ContentTypeEnum.FORM_URLENCODED },
  });

export const fetchEtfLatestNetValue = (productCode: string) =>
  defHttp.get<LatestNetValueType>({
    url: Api.LATEST_NET_VALUE,
    params: { productCode },
  });

// ETF净值表现导出
export const fetchEtfExportNetValueTrend = (params) =>
  defHttp.get(
    {
      url: Api.ETF_EXPORT_NET_VALUE_TREND,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

export const tradableShareExport = (productCode: string) =>
  defHttp.get(
    {
      url: Api.ETF_ASSET_CHANGE_EXPORT_CIRCULATION,
      params: { productCode },
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

export const limitationShareExport = (productCode: string) =>
  defHttp.get(
    {
      url: Api.ETF_ASSET_CHANGE_EXPORT_RESTRICTED,
      params: { productCode },
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );
/**
 * [查询ETF日度指标](https://exmt-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/ETF%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getDayMetric)
 */
export const fetchEtfDailyMetric = (params: Pick<MetfBaseParams, 'productCode'>) =>
  defHttp.get<MetricType>({
    url: Api.ETF_DAILY_METRIC,
    params,
  });

export const fetchEtfAssetDroTrend = (productCode: string) =>
  defHttp.post<IEtfAssetDroTrend[]>({
    url: `${Api.ETF_ASSET_DRO_TREND}?productCode=${productCode}`,
  });

export const fetchEtfAssetLatestDro = (productCode: string) =>
  defHttp.get<IEtfAssetLatestDro>({
    url: Api.ETF_ASSET_LATEST_DRO,
    params: { productCode },
  });

export const fetchEtfAssetListExport = (params: EtfBrandParams) =>
  defHttp.get(
    {
      url: Api.ETF_ASSET_LIST_EXPORT,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

export const fetchEtfAssetTrendExport = (params: MetfBaseParams) =>
  defHttp.get(
    {
      url: Api.ETF_ASSET_TREND_EXPORT,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

export const fetchEtfCashFlowExport = (productCode: string) => {
  return defHttp.post(
    {
      url: `${Api.ETF_CASH_FLOW_EXPORT}?productCode=${productCode}`,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );
};

export const fetchAnalysisFileDown = (params: MetfBaseParams) =>
  defHttp.get(
    {
      url: Api.ANALYSIS_FILE_DOWN,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

export const fetchGetAllFile = (productCode: string) =>
  defHttp.get<IGetAllFileResult>({
    url: Api.GET_ALL_FILE,
    params: { productCode },
  });

export const fetchThousandYuanList = (productCode: string) =>
  defHttp.get<EtfThousandYuan>({
    url: Api.THOUSAND_YUAN_LIST,
    params: { productCode },
  });

export const fetchThousandYuanFlow = (productCode: string) =>
  defHttp.get<EtfThousandYuanFlow[]>({
    url: Api.THOUSAND_YUAN_FLOW,
    params: { productCode },
  });

export const fetchEtfBondMetric = (productCode: string) => {
  return defHttp.get<IEtfBondMetricTrendItem>({
    url: Api.ETF_BOND_METRIC,
    params: { productCode },
  });
};

export const fetchEtfBondMetricTrend = (productCode: string) => {
  return defHttp.get<IEtfBondMetricTrendItem[]>({
    url: `${Api.ETF_BOND_METRIC_TREND}?productCode=${productCode}`,
  });
};
export const fetchEtfAssetBrandExport = (params: EtfBrandParams) =>
  defHttp.get(
    {
      url: Api.ETF_ASSET_BRAND_EXPORT,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

export const fetchEtfAssetRegionExport = (params: EtfBrandParams) =>
  defHttp.get(
    {
      url: Api.ETF_ASSET_REGION_EXPORT,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

export const fetchEtfBrandTopTrend = (params: IEtfTopListQuery) =>
  defHttp.post<EtfIndustryResult>({
    url: Api.ETF_ASSET_BRAND_TOP_TREND,
    params,
  });

export const fetchEtfRegionTopTrend = (params: IEtfTopListQuery) =>
  defHttp.post<EtfIndustryResult>({
    url: Api.ETF_ASSET_REGION_TOP_TREND,
    params,
  });

export const submitEtfOrder = (data: ITradeForm) =>
  defHttp.post(
    {
      url: Api.ETF_ORDER_SUBMIT,
      data,
    },
    {
      isTransformResponse: false,
    },
  );

export const getAvailableShares = (data: IAvailableShares) =>
  defHttp.post({
    url: Api.ETF_GET_AVAILABLE_SHARES,
    data,
  });

export const getPaperRecord = (data: IPaperRecord) =>
  defHttp.post({
    url: Api.PAPER_GET_RECORD,
    data,
  });

export const fetchPaperSigh = (data: IPaperRecord) =>
  defHttp.post({
    url: Api.PAPER_SIGH,
    data,
  });
